import type { MessageAttachment } from "@herskin/contracts";

export type MessageAttachmentPreviewKind = "image" | "video" | "text" | "other";

export type MessageAttachmentView = MessageAttachment;

export interface TextPreview {
  lines: string[];
  truncated: boolean;
}

export const TEXT_PREVIEW_MAX_LINES = 5_000;

export function attachmentPresentationKind(
  attachment: MessageAttachmentView,
): MessageAttachmentPreviewKind {
  return attachment.presentation === "file" ? "other" : attachment.presentation;
}

/** 逻辑行兼容 CRLF、LF 与旧式 CR；尾部换行会保留最后一条空逻辑行。 */
export function logicalTextLines(text: string, maxLines = TEXT_PREVIEW_MAX_LINES): TextPreview {
  const lines = text.split(/\r\n|\r|\n/);
  return {
    lines: lines.slice(0, maxLines),
    truncated: lines.length > maxLines,
  };
}

/**
 * 只读取服务端给出的受控 URL，不创建 object URL，也不回显代理层 HTML 错误正文。
 */
export async function fetchTextAttachmentPreview(contentUrl: string): Promise<TextPreview> {
  let response: Response;
  try {
    response = await fetch(contentUrl, { credentials: "same-origin" });
  } catch {
    throw new Error("附件预览连接中断");
  }
  if (!response.ok) throw new Error(`附件预览加载失败（HTTP ${response.status}）`);
  return logicalTextLines(await response.text());
}
